<template>
  <!--Insured INFO-->
  <div class="md-layout-item md-size-100">
    <md-card>
      <span style="margin-left: 15px; margin-top: 12px; font-size: .85rem; font-weight: 400; color: green">
        Insured Information
      </span>
      <md-button style="width: 200px; align-self: end; margin-right: 12px;" class="md-primary" v-if="showEditInsured" @click="openModal">Edit Informations</md-button>
      <md-card-content>
        <div class="md-layout md-gutter">
          <label class="md-layout-item md-size-15 md-form-label">Insurance ID</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2">
              {{ patientInfo.insuranceID || "-" }}
            </md-field>
          </div>

          <label class="md-layout-item md-size-15 md-form-label">Group Number</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2">{{ patientInfo.groupNumber || "-" }}</md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <label class="md-layout-item md-size-15 md-form-label">Company</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2">{{ patientInfo.insurance || "-" }}</md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <label class="md-layout-item  md-size-15 md-form-label">Name</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2">{{ insurerInfo.fullName || "-" }}</md-field>
          </div>

          <label class="md-layout-item md-size-15 md-form-label">Relationship</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2">{{ patientInfo.relationshipToInsured || "-" }}</md-field>
          </div>
        </div>

        <div class="md-layout md-gutter">
          <label class="md-layout-item md-size-15 md-form-label">DOB (Age)</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2" v-html="getFormattedAge"></md-field>
          </div>

          <label class="md-layout-item md-size-15 md-form-label">Gender</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2" style="text-transform: capitalize;">
              {{ insurerInfo.gender || "-" }}
            </md-field>
          </div>
        </div>

        <div class="md-layout md-gutter">
          <label class="md-layout-item md-size-15 md-form-label">Address</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2">{{ getAddress }}</md-field>
          </div>
        </div>

        <div class="md-layout md-gutter">
          <label class="md-layout-item md-size-15 md-form-label">City/St/Zip</label>
          <div class="md-layout-item" style="padding-left:5px;">
            <md-field class="field2">{{ getCityStZip }}</md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <edit-insured-informations-modal
      :isOpen="modalOpen"
      :patientInfo="patientInfo"
      :insuredInfo="insurerInfo"
      @close="modalOpen = false"
      @saved="refreshData"
    />
  </div>
</template>

<script>
import moment from "moment"
import { mapGetters } from "vuex"
import EditInsuredInformationsModal from "../../modals/EditInsuredInformationsModal.vue"
export default {
  name: "InfoPatientInsurer",
  components: { EditInsuredInformationsModal },

  data() {
    return {
      insurance: "",
      modalOpen: false,
    }
  },
  computed: {
    ...mapGetters(["patientInfo", "insurerInfo", "screeningInfo"]),
    getDob() {
      return !this.insurerInfo.dob ? null : moment(this.insurerInfo.dob, "YYYY-MM-DD").format("l")
    },
    getAge() {
      return !this.insurerInfo.dob ? null : moment().diff(this.insurerInfo.dob, "years", false)
    },
    getFormattedAge() {
      const birth = this.getDob
      const age = this.getAge

      if (!birth || !age) return "-"
      return `<span>${this.getDob}&nbsp;&nbsp;&nbsp;&nbsp;[ ${age} ]</span>`
    },
    getAddress() {
      var addr = this.insurerInfo.address
      if (addr && addr.address) {
        return !addr.address.trim() ? "-" : addr.address
      }
      return "-"
    },
    getCityStZip() {
      var addr = this.insurerInfo.address
      if (!addr) return "-"

      var city = !addr.city.trim() ? "-" : addr.city + ","
      var state = !addr.state.trim() ? " " : addr.state + " -"
      var zip = !addr.zip.trim() ? " " : addr.zip
      var addrPartB = city + " " + state + " " + zip
      return addrPartB
    },
    showEditInsured() {
      const role = sessionStorage.getItem("role")
      return role === 'Technician' || role === 'Reader'
    }
  },
  methods: {
    mouseOver: function() {},
    mouseLeave: function () { },
    openModal() {
      this.modalOpen = true;
    },
    refreshData() {
      this.$store.dispatch("loadScreening", { screeningID: sessionStorage.getItem("screeningID"), detailed: true })
    }
  }
}
</script>

<style lang="scss" scoped>
#screening {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.label {
  font-size: 0.75rem;
  font-weight: 500;
}

.field {
  font-size: 0.95rem;
  font-weight: 400;
  color: rgb(0, 0, 139);
}

.field2 {
  font-size: 0.85rem;
  font-weight: 400;
  color: rgb(0, 0, 139);
  padding-left: 7px;
  padding-bottom: 7px;
  margin-top: 5px;
}

.md-card .md-card-content .md-form-label {
  color: rgb(124, 124, 124);
  font-weight: 400;
  margin-bottom: 0;
  line-height: 1;
  padding-top: 10px;
}
</style>